import React, { useState, useEffect, useContext, useRef } from 'react';
import classNames from 'classnames';
import { Link } from "react-router-dom"
import { CSSTransition as ReactTransitionGroupCssTransition } from "react-transition-group";
import { useTranslation } from "react-i18next";
import keycode from "keycode";

import LoginDropdown from './LoginDropdown';
import HeaderMobileComponent from "../companyProfileToDo/MobileViewComp";
import EuropeMenu from "../subHeader/EuropeMenu";
import { AppContext, ContextType } from "@/shared/context";
import { body, isNotUndefined, consolidatedHeaderObject, getViewportIsMobile } from "@/shared/FunctionCore";
import homepageLogoUrl from "@/resources/original/logo-dnb.svg"
import "@/styles/AppHeaderStyles.scss";
import GlobalMenu from '../subHeader/GlobalMenu';
import { businessCreditURL, businessGrowthURL, businessRiskURL, dunsNumberMythsURL, dunsNumberURL, enterpriseURL, globeHeaderIconURL, publicSectorURL, resourcesHeaderURL, serviceCenterURL } from '@/shared/constant';

const AppHeader = ({
	hideSearchBoolean,
	useMinifiedHeaderBoolean,
	isTaiwan,
	loginMenuOpen,
	setLoginMenuOpen,
	countryCode
}): JSX.Element => {
	const { t } = useTranslation();
	const [showSearchOption, setShowSearchOption] = useState(false);
	const { setIsBDTabClicked, isEuBd, isUnitedStates } = useContext(AppContext) as ContextType
	const [isSearchOverlayOpen, setIsSearchOverlayOpen] = useState(false);
	const consolidatedHeaderProductLoginReferenceHtmlInnerWrapperReference = useRef<HTMLDivElement>(null);
	const [viewportIsMobile, setViewportIsMobile] = useState(false);
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
	const homeRedirection = t("homeRedirection");

	useEffect(() => {
		if (!loginMenuOpen) {
			closeProductLogin()
		} else if (showSearchOption) {
			setShowSearchOption(false)
		}
	}, [loginMenuOpen])

	useEffect(() => {
		const $body = $(body);
		const $app_page = $("#app_page");
		const $window = $(window);

		$body.on("click", (cl) => {
			const target = cl.target;

			const $targetAndParents = $(target).parents().addBack();

			// if (
			// 		$targetAndParents.filter(`.$("consolidatedHeaderLanguageWrapper")[1]}`)
			// 				.length === 0
			// ) {
			// 		setLanguageOptionsOpen(false);
			// }

			if (
				$targetAndParents.filter(`.${'consolidatedHeaderLoginButton'[1]}`).length ===
				0 &&
				$targetAndParents.filter(
					`.${'search-dropdown-menu'[1]}`
				).length === 0
			) {
				setShowSearchOption(false);
			}
		});

		const $productLoginDropDown = $("#productLoginDropDown");

		$productLoginDropDown.on("click", (cl) => {
			const afv = isNotUndefined(cl.target.id) && cl.target.id === "productLoginCloseButton"

			if (!afv) cl.stopPropagation();
		});

		// ===================================

		const $consolidatedHeaderInnerWrapper = $(`.consolidatedHeaderInnerWrapper`);
		const $consolidatedHeaderWrapper = $(".consolidatedHeaderWrapper");

		let headerHeight = 0;
		let headerTransitionClassAdded = false;
		let isFirstNonMobileScrollPastHeaderHeight = true;
		let lastWindowPageYOffset = 0;

		const resetToInitialState = () => {
			headerTransitionClassAdded = false;
			isFirstNonMobileScrollPastHeaderHeight = true;

			consolidatedHeaderObject.headerPosition = false;

			$consolidatedHeaderWrapper.removeClass("position");
			$consolidatedHeaderWrapper.removeClass("transition");

			$consolidatedHeaderWrapper.css("top", 0);
			$app_page.css("margin-top", 0);
		};

		const setHeaderHeight = () => {
			// Measure header
			const consolidatedHeaderInnerWrapperOuterHeight = $consolidatedHeaderInnerWrapper.outerHeight();

			if (isNotUndefined(consolidatedHeaderInnerWrapperOuterHeight)) {
				headerHeight = consolidatedHeaderInnerWrapperOuterHeight;
			}
		};

		const setStyles = () => {
			$consolidatedHeaderWrapper.css("top", consolidatedHeaderObject.showHeader ? 0 : -1 * (headerHeight + 52));
			$app_page.css("margin-top", headerHeight);
		};

		const updateStylesIfNecessary = () => {
			if (!isFirstNonMobileScrollPastHeaderHeight) {
				setStyles();
			}
		};

		consolidatedHeaderObject.onHeaderHeightChange = () => {
			setHeaderHeight();
			updateStylesIfNecessary();
		};

		setHeaderHeight();
		$window.on("scroll", () => {
			// Scroll handler for nonmobile viewports
			if (!getViewportIsMobile()) {
				const windowPageYOffset = window.pageYOffset;

				// Ignore scroll events that don't change the scroll position
				if (windowPageYOffset !== lastWindowPageYOffset) {
					// Determine scroll direction
					const scrollDirectionIsUp = windowPageYOffset < lastWindowPageYOffset;

					consolidatedHeaderObject.showHeader = scrollDirectionIsUp;

					// Save current scroll position
					lastWindowPageYOffset = windowPageYOffset;

					if (windowPageYOffset > headerHeight) {
						if (isFirstNonMobileScrollPastHeaderHeight) {
							isFirstNonMobileScrollPastHeaderHeight = false;

							consolidatedHeaderObject.headerPosition = true;

							$consolidatedHeaderWrapper.addClass("position");
						} else if (!headerTransitionClassAdded && scrollDirectionIsUp) {
							headerTransitionClassAdded = true;

							$consolidatedHeaderWrapper.addClass("transition");
						}

						setStyles();
					} else if (windowPageYOffset === 0) {
						resetToInitialState();
					}
				}
			}
		});

		const mediaQueryList = window.matchMedia("screen and (max-width: 991px)");
		// Initial check when component mounts
		checkViewportIsMobile(mediaQueryList);
		mediaQueryList.addEventListener("change", checkViewportIsMobile);

		// Clean up by removing the event listener on unmount
		return () => {
			mediaQueryList.removeEventListener("change", checkViewportIsMobile);
		};
	}, [])

	const checkViewportIsMobile = (me) => {
		const matches = me.matches;
		setViewportIsMobile(matches); // Update state
		document?.querySelector("html")?.classList.toggle("mobile", matches);
	};

	const toggleSearchOverlay = () => {
		setIsSearchOverlayOpen(!isSearchOverlayOpen);
	}

	const syncDropDowns = (current, flag) => {
		if (current === "optionsBox") {
			if (!flag && loginMenuOpen) { // is false means, its about to open and login menu is also open
				setLoginMenuOpen(false)
			}
		}
	}

	const closeProductLogin = () => {
		const current = consolidatedHeaderProductLoginReferenceHtmlInnerWrapperReference.current;

		if (current !== null) {
			const $current = $(current);

			$current.hide();

			setLoginMenuOpen(false);
		}
	};

	return (
		<ReactTransitionGroupCssTransition
			classNames={classNames("enterActive", "enterDone", "exit", "exitActive")}
			in={isSearchOverlayOpen}
			timeout={600}
		>
			<div>
				<div className={`consolidatedHeaderWrapper isTaiwan-${isTaiwan}`}>
					<div className="consolidatedHeaderInnerWrapper">
						{viewportIsMobile ? (
							<HeaderMobileComponent />

						) : (
							<>
								<header>
									<nav className="navBarMenuBlue text-white navbar navbar-expand-lg">
										<div className="container-fluid">
											<div className="collapse navbar-collapse" id="navbarScroll">
												<ul className="navbar-nav navbarMain me-auto navbar-nav-scroll">
													<li className="nav-item">
														<a className="nav-link" aria-current="page" href={enterpriseURL}>
															Enterprise
														</a>
													</li>
													<li className="nav-item nav-link-always-active">
														<Link className="nav-link active" to='/'>
															Small Business
														</Link>
													</li>
													<li className="nav-item">
														<a className="nav-link" href={publicSectorURL}>
															Public Sector
														</a>
													</li>
												</ul>
												<ul className="navbar-nav navbarSearch my-2 my-lg-0 navbar-nav-scroll">
													<li className="nav-item dropdown d-flex" onClick={(e) => {
														e.stopPropagation();
														setShowSearchOption((flag) => {
															syncDropDowns("optionsBox", flag)
															return !flag
														})
													}}>
														<a
															role="button"
															className={classNames({
																"nav-link d-flex": true,
																"show": showSearchOption
															})}
															type="button"
															data-bs-toggle="dropdown"
															aria-expanded={showSearchOption}
														>
															<div className="headerSearchIcon" />
															{t("searchOptions")}
														</a>
														<ul className={classNames({
															"dropdown-menu search-dropdown-menu": true,
															"show": showSearchOption
														})}>
															<li>
																<Link className="dropdown-item" to="/site-search-results.html">
																	{t("businessDirectory.siteContentTab")}
																</Link>
															</li>
															<li>
																<Link className="dropdown-item" to="/">
																	{t("businessDirectory.bdBrowserTabTitle")}
																</Link>
															</li>
															<li>
																<Link className="dropdown-item" to="/contact-directory.html">
																	{t("contactDirectory.contact_directory")}
																</Link>
															</li>
															<li>
																<Link className="dropdown-item" to='/site-search-results.html'>
																	{t("businessDirectory.marketplace")}
																</Link>
															</li>
														</ul>
													</li>
													<li className="nav-item">
														<a className="nav-link" href={dunsNumberURL}>
															D‑U‑N‑S Number
														</a>
													</li>
													<li className="nav-item">
														<Link className="nav-link" to="/">
															Business Directory
														</Link>
													</li>
													<li className="nav-item">
														<a className="nav-link" href={serviceCenterURL}>
															Service Center
														</a>
													</li>
													<li className="nav-item">
														<a className="nav-link d-flex" onClick={(e) => {
															const current =
																consolidatedHeaderProductLoginReferenceHtmlInnerWrapperReference.current;
															e.stopPropagation();
															if (current !== null) {
																const $current = $(current);
																$current.slideToggle(100);
																setLoginMenuOpen((va) => !va);
															}
														}}
															role='button'
														>
															<div className="headerUserLoginIcon" />
															Log In
														</a>
													</li>
													{isTaiwan ? <></> :
														(<li className="nav-item">
															<a className="nav-link"
																aria-label="Choose Your Country"
																href={globeHeaderIconURL}
															>
																<div className="headerInternationalSiteSelector" />
															</a>
														</li>)}
												</ul>
											</div>
										</div>
									</nav>
								</header>
								<div className="consolidatedHeaderDesktopOuterWrapper">
									<div className="consolidatedHeaderDesktop">
										<div className="consolidatedHeaderDesktopInnerWrapper">
											<div className="consolidatedHeaderBeginningPadding" />
											<div className="consolidatedHeaderLogoWrapper">
												<Link
													aria-label="Homepage link"
													to={homeRedirection}
												>
													{homepageLogoUrl ? (
														<img
															alt="D&B logo"
															className="consolidatedHeaderLogo"
															src={homepageLogoUrl}
														/>
													) : (
														<div
															aria-label="D&B logo"
															className={classNames(
																"consolidatedHeaderLogo",
																"consolidatedHeaderLogoBG"
															)}
															role="img"
														/>
													)}
												</Link>
											</div>
											<div className="consolidatedHeaderMiddlePadding"></div>
											<div
												className="consolidatedHeaderSearchAndLinksWrapper"
											>
												<div className="consolidatedHeaderLinksWrapper">
													<div className="consolidatedHeaderLinkWrapper">
														<a
															className="consolidatedHeaderLink"
															href={dunsNumberMythsURL}
														>
															D‑U‑N‑S Number
														</a>
													</div>
													<div className="consolidatedHeaderLinkWrapper">
														<a
															className="consolidatedHeaderLink"
															href={businessCreditURL}
														>
															Business Credit
														</a>
													</div>
													<div className="consolidatedHeaderLinkWrapper">
														<a
															className="consolidatedHeaderLink"
															href={businessGrowthURL}
														>
															Business Growth
														</a>
													</div>
													<div className="consolidatedHeaderLinkWrapper">
														<a
															className="consolidatedHeaderLink"
															href={businessRiskURL}
														>
															Business Risk
														</a>
													</div>
													<div className="consolidatedHeaderLinkWrapper">
														<a
															className="consolidatedHeaderLink"
															href={resourcesHeaderURL}
														>
															Resources
														</a>
													</div>
												</div>
											</div>
											{/* {isTaiwan || hideSearchBoolean ? (
													<></>
												) : (

													<button
														className="consolidatedHeaderSearchButton"
														title="Search here..."
														type="button"
														onClick={(e) => {
															e.stopPropagation()
															setShowSearchOption((flag) => {
																syncDropDowns("optionsBox", flag)

																return !flag
															})
														}}
													>
														<div className={classNames({
															"consolidatedHeaderSearchIcon": !showSearchOption,
															"consolidatedHeaderCloseIcon": showSearchOption
														})} />
													</button>												
												)} */}
											{/* {isTaiwan ? (
												<></>
											) : (
												<>
													{countryCode !== "de" && (
														<div className="consolidatedHeaderLinkWrapper">
															<a
																className="consolidatedHeaderLink"
																href={t("customerSuccessPathRewritten")}
															>
																{t("headerSupportButtonLabel")}
															</a>
														</div>
													)} */}

											{/* {!isUnitedStates &&
														isNotUndefinedOrNull(headerContactButtonLabel) &&
														headerContactButtonLabel.length > 0 ? (
														<div className="consolidatedHeaderLinkWrapper">
															<a
																className="consolidatedHeaderLink"
																href={contactUsPathRewritten}
															>
																{headerContactButtonLabel}
															</a>
														</div>
													) : (
														<></>
													)} */}

											{/* <div className="consolidatedHeaderLinkWrapper">
														<button
															className="consolidatedHeaderLink consolidatedHeaderLoginButton"
															onClick={(e) => {
																const current =
																	consolidatedHeaderProductLoginReferenceHtmlInnerWrapperReference.current;

																e.stopPropagation();

																if (current !== null) {
																	const $current = $(current);
																	$current.slideToggle(100);
																	setLoginMenuOpen((va) => !va);
																}
															}}
															type="button"
														>
															<div className="consolidatedHeaderLoginButtonLabel">
																{t("login")}
															</div>

															<div
																className={`consolidatedHeaderLoginDownArrow loginMenuOpen-${loginMenuOpen}`}
															/>
														</button>
													</div> */}
											{/* </>
											)} */}


											{/* {!viewportIsMobile && !isTaiwan && websiteSelectorIncludeBoolean ? (
																								<WebsiteSelector
																										isoCode={isoCode}
																										siteLanguage={siteLanguage}
																										websiteSelectorSiteArray={websiteSelectorSiteArray}
																										websiteSelectorTitleEn={websiteSelectorTitleEn}
																										websiteSelectorTitleFr={websiteSelectorTitleFr}
																								/>
																						) : (
																								<></>
																						)} */}

											<div className="consolidatedHeaderEndPadding" />
										</div>
									</div>
								</div>
							</>
						)}

						<div className="consolidatedHeaderProductLoginReferenceHtmlWrapper" id="productLoginDropDown">
							<div className="consolidatedHeaderProductLoginReferenceHtmlInnerWrapper"
								ref={consolidatedHeaderProductLoginReferenceHtmlInnerWrapperReference}
							>
								<LoginDropdown setLoginMenuOpen={setLoginMenuOpen} countryCode={countryCode} />
							</div>
						</div>

						{/* {isEuBd &&
						<EuropeMenu
							countryCode= {countryCode} 
							setMobileMenuOpen= {setMobileMenuOpen} 
							mobileMenuOpen = {mobileMenuOpen}
							viewportIsMobile = {viewportIsMobile}
							/>
					} */}
						{/* {isUnitedStates && <GlobalMenu countryCode={countryCode} />} */}

					</div>

					{/* {useMinifiedHeaderBoolean ? (
														<></>
												) : (
														<div className={cx(classCombiner(styles, "consolidatedHeaderSinglePageSearchComponentWrapper"))}>
																<ClickAwayListener
																		onClickAway={handleClickAway}
																		touchEvent={false}>
																		<div>
																				<SinglePageSearchComponent
																						env={void 0}
																						isSearchOverlay={true}
																						isSearchOverlayOpen={isSearchOverlayOpen}
																						resourcePath={void 0}
																						setIsSearchOverlayOpen={setIsSearchOverlayOpen}
																						singlePageSearchData={singlePageSearchData}
																						token={token}
																				/>
																		</div>
																</ClickAwayListener>
														</div>
												)} */}
				</div>
			</div>
		</ReactTransitionGroupCssTransition>
	)
}

export default AppHeader